"use strict";

const RoutineInspectionRouteFactory = require("./routineInspectionRouteFactory");

const ManholeRoutes = function () {
  const inspectionRoute = RoutineInspectionRouteFactory.createRoute({
    resourceKey: "manholeRoutineMaintenance",
    assetType: "manhole",
  });

  const legacyRedirectRoute = RoutineInspectionRouteFactory.createLegacyRedirect({
    assetType: "manhole",
    dataView: "dry-weather",
  });

  return { inspectionRoute, legacyRedirectRoute };
};

module.exports = ManholeRoutes();
